/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * @type NotificationChannelWebhookUrl
 * 
 * @export
 */
export type NotificationChannelWebhookUrl = string;

export function NotificationChannelWebhookUrlFromJSON(json: any): NotificationChannelWebhookUrl {
    return NotificationChannelWebhookUrlFromJSONTyped(json, false);
}

export function NotificationChannelWebhookUrlFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationChannelWebhookUrl {
    if (json == null) {
        return json;
    }
    if (typeof json === 'string') {
        return json;
    }
    if (typeof json === 'string') {
        return json;
    }
    return {} as any;
}

export function NotificationChannelWebhookUrlToJSON(json: any): any {
    return NotificationChannelWebhookUrlToJSONTyped(json, false);
}

export function NotificationChannelWebhookUrlToJSONTyped(value?: NotificationChannelWebhookUrl | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    if (typeof value === 'string') {
        return value;
    }
    if (typeof value === 'string') {
        return value;
    }
    return {};
}

